import React from 'react';
import {
  ManualDownloadSetup,
  ChromeWebStoreSetup,
  FirefoxSetup,
  FirefoxManualDownloadSetup,
} from './browser-setup';
import { WorkspaceConfig } from '../../types/onboarding';
import { getBrowserType } from '../../../../utils/browserUtils';

interface BrowserSetupScreenProps {
  workspace: WorkspaceConfig;
  onComplete: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

const PROD_APP_URL = 'app.plerion.com';

function isValidProdHostname(hostname: string): boolean {
  return hostname === PROD_APP_URL || hostname.endsWith(`.${PROD_APP_URL}`);
}

export const BrowserSetupScreen: React.FC<BrowserSetupScreenProps> = (
  props,
) => {
  const isProd = isValidProdHostname(window.location.hostname);
  const browserType = getBrowserType();

  // Firefox uses simple install in prod, manual download in dev
  if (browserType === 'firefox') {
    if (isProd) {
      return <FirefoxSetup {...props} />;
    }
    return <FirefoxManualDownloadSetup {...props} />;
  }

  // Chrome uses web store in prod, manual download in dev
  if (browserType === 'chrome') {
    if (isProd) {
      return <ChromeWebStoreSetup {...props} />;
    }
    return <ManualDownloadSetup {...props} />;
  }

  // For other browsers, default to Chrome manual download
  return <ChromeWebStoreSetup {...props} />;
};
